import { Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ASSETS } from '@core/constants/assets.constants';
import {
  FEEDBACK_ITEMS,
  FEEDBACK_PANEL,
  FEEDBACK_SURVEY_URL,
  FeedbackAction,
  FeedbackItem,
} from '@core/constants/feedback.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { normalizeExternalUrl } from '@shared/utils/external-url.utils';

@Component({
  selector: 'app-feedback-widget',
  standalone: true,
  templateUrl: './feedback-widget.html',
  styleUrl: './feedback-widget.scss',
})
export class FeedbackWidget {
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);

  readonly isOpen = signal(false);
  readonly logo = ASSETS.LIGHT_LOGO;
  readonly panel = FEEDBACK_PANEL;
  readonly items = FEEDBACK_ITEMS;

  toggle(): void {
    this.isOpen.update((open) => !open);
  }

  close(): void {
    this.isOpen.set(false);
  }

  onItemSelect(item: FeedbackItem): void {
    this.handleAction(item.action);
  }

  openSurvey(): void {
    const url = normalizeExternalUrl(FEEDBACK_SURVEY_URL);
    if (url && isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    this.close();
  }

  onBackdropClick(): void {
    this.close();
  }

  private handleAction(action: FeedbackAction): void {
    if (action.kind === 'survey') {
      this.openSurvey();
      return;
    }

    void this.router.navigate([
      APP_ROUTES.GUEST.SUPPORT.ROOT,
      APP_ROUTES.GUEST.SUPPORT.CONTACT_US,
    ]);
    this.close();
  }
}
